export enum DayOfWeekEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export const dayStringToEnum = (day: string): DayOfWeekEnum => {
  switch (day.toUpperCase().trim()) {
    case 'MON':
    case 'MONDAY':
      return DayOfWeekEnum.MON;
    case 'TUE':
    case 'TUESDAY':
    case 'TUES':
      return DayOfWeekEnum.TUE;
    case 'WED':
    case 'WEDNESDAY': 
    case 'WEDS':
      return DayOfWeekEnum.WED;
    case 'THU': 
    case 'THURSDAY': 
    case 'THURS':
      return DayOfWeekEnum.THU;
    case 'FRI': 
    case 'FRIDAY':
      return DayOfWeekEnum.FRI;
    case 'SAT': 
    case 'SATURDAY':
      return DayOfWeekEnum.SAT;
    case 'SUN': 
    case 'SUNDAY':
      return DayOfWeekEnum.SUN;
    default:
      throw new Error(`Invalid day of week: ${day}`);
  }
};

export const getNumericalDayOfWeek = (dayOfWeek: DayOfWeekEnum): number => {
  const dayMap = {
    [DayOfWeekEnum.SUN]: 0,
    [DayOfWeekEnum.MON]: 1,
    [DayOfWeekEnum.TUE]: 2,
    [DayOfWeekEnum.WED]: 3,
    [DayOfWeekEnum.THU]: 4,
    [DayOfWeekEnum.FRI]: 5,
    [DayOfWeekEnum.SAT]: 6,
  };

  return dayMap[dayOfWeek];
};
